import { TRAMITES, MXN } from "@/lib/api";
import { Eye, Phone, Mail, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ClientCard({ client, onOpen }) {
  const t = client.tramite ? TRAMITES[client.tramite] : null;

  return (
    <div
      data-testid={`client-card-${client.id}`}
      className="group bg-white border border-neutral-200 rounded-2xl p-4 sm:p-5 hover:shadow-md hover:border-yellow-500 transition"
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-3 flex-wrap">
            <h3 className="font-heading text-lg font-semibold text-black truncate">
              {client.nombre_completo}
            </h3>
            {t ? (
              <span
                className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full border"
                style={{
                  backgroundColor: `${t.color}12`,
                  color: t.color,
                  borderColor: `${t.color}55`,
                }}
              >
                <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: t.color }} />
                {t.label}
              </span>
            ) : (
              <span className="text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full border border-dashed border-neutral-300 text-neutral-400">
                Sin trámite
              </span>
            )}
            <span className="text-[11px] font-semibold px-2 py-0.5 rounded-md bg-black text-yellow-400">
              {client.zona}
            </span>
          </div>
          <div className="mt-2 flex flex-wrap gap-x-5 gap-y-1 text-xs text-neutral-500 font-mono">
            <span>NSS: <span className="text-neutral-800">{client.nss}</span></span>
            <span>CURP: <span className="text-neutral-800">{client.curp}</span></span>
            {client.telefono && (
              <span className="inline-flex items-center gap-1"><Phone className="w-3 h-3" />{client.telefono}</span>
            )}
            {client.email && (
              <span className="inline-flex items-center gap-1"><Mail className="w-3 h-3" />{client.email}</span>
            )}
            {client.direccion && (
              <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" />{client.direccion}</span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-3">
          {client.cobro ? (
            <div className="text-right">
              <div className="text-[10px] uppercase tracking-wider text-neutral-400">Cobro</div>
              <div className="font-mono font-semibold text-yellow-700">{MXN(client.cobro)}</div>
            </div>
          ) : null}
          <Button
            data-testid={`view-client-${client.id}`}
            variant="outline"
            size="icon"
            onClick={onOpen}
            className="rounded-full h-10 w-10 border-neutral-300 hover:bg-yellow-50 hover:border-yellow-500 hover:text-black"
            title="Ver detalle"
          >
            <Eye className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
